// shared/utils/metros.ts
export const esProductoEnMetros = (p: any) =>
  p?.producto_data?.usa_metros === true &&
  p?.contiene_serie === true &&
  Number(p?.producto_data?.metros_base) > 0;

export const metrosAUnidades = (p: any, metros: number) =>
  esProductoEnMetros(p)
    ? Math.ceil((Number(metros) || 0) / Number(p.producto_data.metros_base))
    : (Number(metros) || 0);